export const PASSWORD_VALIDATE = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.*[^\s]).{8,}$/);
export const EMAIL_PATTERN = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const PLAN_MONTHS = [
    {
        label: '1 Month',
        value: '1'
    },
    {
        label: '2 Month',
        value: '2'
    },
    {
        label: '3 Month',
        value: '3'
    },
    {
        label: '4 Month',
        value: '4'
    }
];
